import { render, staticRenderFns } from "./Need.vue?vue&type=template&id=7d1d4fe2&"
import script from "./Need.vue?vue&type=script&lang=js&"
export * from "./Need.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports